export const generateFAQSchema = (faq: { question: string; answer: string }[]) => {
    let jsonLd = "";

    if (faq.length) {
        // Generate schema
        const faqSchema = {
            "@context": "https://schema.org",
            "@type": "FAQPage",
            mainEntity: faq.map((faq) => ({
                "@type": "Question",
                name: faq.question,
                acceptedAnswer: {
                    "@type": "Answer",
                    text: faq.answer
                }
            }))
        };

        // Convert to JSON-LD string (formatted for HTML embedding)
        jsonLd = JSON.stringify(faqSchema, null, 2);
    }

    return jsonLd;
};
